import "./rma-list-settings-button.scss";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import { Button } from "../../../../../components/inputs/button/button";
import { observer } from "mobx-react";
import RmaListSettingsPopup from "./rma-list-settings-popup";
import { useState } from "react";
import uiSettingsStore from "../../../../../stores/ui-settings-store";
import IconSettings from "../../../../../components/icons/icon-settings/icon-settings";
import { BUTTON_VARIANTS } from "../../../../../components/inputs/button-variants";
import {
    MANAGE_RETURNS_DESIGN_VERSION,
    trackManageReturnsListEvent,
} from "../../../utils/manage-returns-list-mixpanel";


const RmaListSettingsButton: React.FC = observer(() => {
    const [showSettingsPopup, setShowSettingsPopup] = useState(false);
    const scope = 'dashboard-returns-page';
    const { getTranslation } = useDashboardTranslation();

    return (
        <div className="rma-list-settings-button">
            <Button
                onClick={() => {
                    trackManageReturnsListEvent(
                        "d&_return_table_settings_button_save",
                        MANAGE_RETURNS_DESIGN_VERSION.V1,
                    );
                    setShowSettingsPopup(true);
                }}
                text={getTranslation('SETTINGS', scope)}
                isLoading={uiSettingsStore.isLoading}
                variant={BUTTON_VARIANTS.Secondary}
                leftIcon={IconSettings}
            />
            {showSettingsPopup && <RmaListSettingsPopup
                onClose={() => setShowSettingsPopup(false)}
            />}
        </div>
    );
});


export default RmaListSettingsButton;
